import { Component } from 'react';
import { createPortal } from 'react-dom';

const popupsRoot = document.getElementById('popups-root');

class PopupPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    if (!popupsRoot) return;
    popupsRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    if (!popupsRoot) return;
    popupsRoot.removeChild(this.el);
  }

  render() {
    return createPortal(this.props.children, this.el);
  }
}

export default PopupPortal;
